export enum SendIntegrationPrivateKeyType {
    P8 = 'P8',
    P12 = 'P12',
}
